import { useEffect, useState } from 'react';
import { Col, Form, Modal, message } from 'antd';
import { BookyInput } from '../Forms/BookyInput';
import { BookyButton } from '../Buttons/BookyButton';
import { GroupService } from '../../Services/GroupService';
import { TextService } from '../../Services/TextService';
import { BookyCheckbox } from '../Forms/BookyCheckbox';
import { GroupType } from '../../Types/GroupType';
import { WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';

export const CreateGroupButton = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;

    const onCancel = () => {
        form.setFieldValue("groupName", "");
        setOpen(false);
    };

    useEffect(() => {
    }, [form])

    const onCreate = async (values: any) => {
        try {
            if (values.isDefault) {
                const groupsDefault = props.groups.filter((p: WebApiServicesDataTransferObjectsGroupServiceGroupResultDto) => p.groupType == GroupType.Default)
                if (groupsDefault.length > 0) {
                    message.warning(GetText("CreateGroup_ErrorAlreadIsOneStandardGroup"));
                    return;
                }
            }

            await GroupService.CreateGroup({
                name: values.groupName,
                groupType: values.isDefault == true ? GroupType.Default : GroupType.Unspecified,
                members: []
            });
        } catch (error) {
            message.warning(GetText("CreateGroup_ErrorAlreadyExist"));
            return;
        }

        form.setFieldValue("groupName", "");
        setOpen(false);

        props.reloadGroup();
    }

    return (
        <>
            <Modal
                open={open}
                title={GetText("CreateGroup_ModalHeader")}
                okText={GetText("CreateGroup_CreateText")}
                cancelText={GetText("CreateGroup_CancelText")}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                }}
                onCancel={onCancel}
            >
                <Form form={form} disabled={props.user?.hasOnlyReadRights} layout="horizontal"
                    onFinish={onCreate}>
                    <Col span={24}>
                        <BookyInput name="groupName" requiredMessage={GetText("CreateGroup_RequiredText")} placeholder={GetText("CreateGroup_PlaceHolderText")} />
                        <BookyCheckbox name="isDefault" alignLabelRight={true} label={"Nya medlemmar går med i denna grupp automatiskt"} />
                    </Col>
                </Form>
            </Modal >

            <div>
                <BookyButton
                    type="primary"
                    disabled={props.user?.hasOnlyReadRights}
                    fullWidth={false}
                    text={GetText("CreateGroup_CreateText")}
                    onClick={() => {
                        setOpen(true);
                    }}
                >

                </BookyButton>
            </div>
        </>
    );
};

export default CreateGroupButton;